import Reveal from "./Reveal";

const IMG_CAD =
  "https://images.unsplash.com/photo-1586868538513-51335a0c5337?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZGVzaWduJTIwcHJvdG90eXBlfGVufDB8fHx8MTc5MDI0Njk1N3ww&ixlib=rb-4.1.0&q=85";
const IMG_CALIPER =
  "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxpbmR1c3RyaWFsJTIwZGVzaWduJTIwcHJvdG90eXBlfGVufDB8fHx8MTc5MDI0Njk1N3ww&ixlib=rb-4.1.0&q=85";
const IMG_PRINT =
  "https://images.pexels.com/photos/20688553/pexels-photo-20688553.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

function ServiceCard({ img, alt, tag, title, desc, badge, testid, className = "" }) {
  return (
    <article
      data-testid={testid}
      className={`corner-card group relative flex h-full flex-col overflow-hidden rounded-[20px] border border-black/10 bg-white transition-colors duration-300 hover:border-black/25 ${className}`}
    >
      <div className="overflow-hidden">
        <img
          src={img}
          alt={alt}
          className="h-52 w-full object-cover transition-transform duration-700 group-hover:scale-[1.04] sm:h-56"
        />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">{tag}</span>
        <h2 className="mt-2 font-display text-lg font-bold tracking-tight text-ink sm:text-xl">{title}</h2>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-neutral-600">{desc}</p>
        <span className="mt-4 inline-flex w-fit items-center rounded-full border border-black/10 bg-mist px-3 py-1 font-mono text-[10px] uppercase tracking-[0.16em] text-neutral-600">
          {badge}
        </span>
      </div>
    </article>
  );
}

export default function ServicesShowcase() {
  return (
    <section id="services" className="scroll-mt-20 py-16 lg:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid grid-cols-1 gap-5 md:grid-cols-12">
          <Reveal className="md:col-span-7" delay={0.05}>
            <ServiceCard
              img={IMG_CAD}
              alt="Conception d'un modèle 3D sur logiciel de CAO"
              tag="Création"
              title="Conception & modélisation 3D sur mesure"
              desc="Modélisation 3D à partir de votre idée, d'un croquis ou de cotes. Fichiers .STL, .STEP et .OBJ livrés prêts à l'emploi."
              badge="Fichiers universels"
              testid="service-card-creation"
            />
          </Reveal>
          <Reveal className="md:col-span-5" delay={0.12}>
            <ServiceCard
              img={IMG_CALIPER}
              alt="Prise de cotes précise au pied à coulisse"
              tag="Réparation"
              title="Réparation & pièces détachées 3D"
              desc="Pièce cassée ou introuvable dans le commerce ? Envoyez photos et cotes : nous la remodélisons à l'identique."
              badge="Zéro obsolescence"
              testid="service-card-repair"
            />
          </Reveal>
          <Reveal className="md:col-span-5" delay={0.05}>
            <ServiceCard
              img={IMG_PRINT}
              alt="Pièce géométrique en cours d'impression 3D"
              tag="Fabrication additive"
              title="Impression 3D à la demande"
              desc="Impression de vos pièces en PLA ou PETG, à l'unité ou en petite série, dans la couleur de votre choix. Volume max 220 × 220 × 220 mm par pièce, assemblage possible."
              badge="PLA · PETG · couleurs au choix"
              testid="service-card-print"
            />
          </Reveal>
          <Reveal className="md:col-span-7" delay={0.12}>
            <article
              data-testid="service-card-specs"
              className="corner-card flex h-full flex-col justify-between rounded-[20px] border border-black/10 bg-mist p-6 sm:p-8"
            >
              <div>
                <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">
                  Formats & matières
                </span>
                <h2 className="mt-2 font-display text-lg font-bold tracking-tight text-ink sm:text-xl">
                  Ce que vous recevez, concrètement.
                </h2>
              </div>
              <dl className="mt-6 divide-y divide-black/5 font-mono text-xs">
                {[
                  ["FICHIERS LIVRÉS", ".STL / .STEP / .OBJ"],
                  ["MATIÈRES IMPRESSION", "PLA standard · PLA carbone · PETG"],
                  ["VOLUMES", "Pièce unitaire & petite série"],
                ].map(([k, v]) => (
                  <div key={k} className="flex flex-col gap-1 py-3.5 sm:flex-row sm:items-center sm:justify-between">
                    <dt className="uppercase tracking-[0.18em] text-neutral-500">{k}</dt>
                    <dd className="text-sm font-medium text-ink sm:text-right">{v}</dd>
                  </div>
                ))}
              </dl>
            </article>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
